<nz-spin [nzSpinning]="loading$ | async" nzSize="small">
  <nz-row nzJustify="center" class="manufacturers-row">
    <a
      *ngFor="let manufacturer of manufacturers$ | async"
      nz-button
      nzType="primary"
      nzSize="small"
      class="top"
      [attr.href]="isExternalLink(manufacturer.link) ? href(manufacturer.link) : null"
      [routerLink]="isExternalLink(manufacturer.link) ? null : linkPath(manufacturer.link)"
      [queryParams]="isExternalLink(manufacturer.link) ? null : linkQuery(manufacturer.link)"
      [fragment]="isExternalLink(manufacturer.link) ? null : linkFragment(manufacturer.link)"
      [target]="isExternalLink(manufacturer.link) ? '_blank' : null"
      [attr.target]="isExternalLink(manufacturer.link) ? '_blank' : null"
      [attr.rel]="isExternalLink(manufacturer.link) ? 'noopener' : null"
    >
      {{ manufacturerTitle(manufacturer) }}
    </a>
  </nz-row>
</nz-spin>
